import './styles.scss';

import { each, filter, map } from 'lodash';
import axios from 'axios';
import { BASE_URL } from '@/constants/constants';

const CheckboxGroup = () => import('../../components/checkbox-group/index.vue');
const rootUrl = BASE_URL;

export default {
    name: 'MessagingPreviewPage',

    components: {
        'checkbox-group': CheckboxGroup
    },

    data() {
        return {
            roles: [],
            group_types: [],
            floors: [],
            notification_types: [],
            message: ''
        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        stored_roles() {
            return this.$store.state.messaging.roles;
        },

        stored_group_types() {
            return this.$store.state.messaging.group_types;
        },

        stored_floors() {
            return this.$store.state.messaging.floors;
        },

        stored_notification_types() {
            return this.$store.state.messaging.notification_types;
        },

        stored_message() {
            return this.$store.state.messaging.message;
        },

        can_send() {
            const has_roles  = filter(this.roles, { isChecked: true }).length;
            const has_groups = filter(this.group_types, { isChecked: true }).length;
            const has_floors = filter(this.floors, { isChecked: true }).length;
            const has_types  = filter(this.notification_types, { isChecked: true }).length;
            
            return has_types && this.message !== '' && (has_roles || has_floors || has_groups);
        }
    },

    created() {
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action/emergency-messages/compose-message'
        });

        this.roles = this.stored_roles;
        this.group_types = this.stored_group_types;
        this.floors = this.stored_floors;
        this.notification_types = this.stored_notification_types;
        this.message = this.stored_message;
    },

    methods: {
        updateRoles(list) {
            this.roles = list;
            this.$store.commit('setMessageRoles', list);
        },

        updateGroupTypes(list) {
            this.group_types = list;
            this.$store.commit('setMessageGroupTypes', list);
        },

        updateFloors(list) {
            this.floors = list;
            this.$store.commit('setMessageFloors', list);
        },

        updateNotificationTypes(list) {
            this.notification_types = list;
            this.$store.commit('setMessageNotificationTypes', list);
        },

        updateMessage(message) {
            this.message = message;
            this.$store.commit('setMessage', message);
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        },

        async messageHandler() {
            
            const data = new FormData();
            
            data.append('body', this.message);
            
            each(this.roles, (role) => {
                if (role.isChecked) {
                    data.append('user_tier[]', role.id);
                }
            });

            each(this.group_types, (group) => {
                if (group.isChecked) {
                    data.append('user_group[]', group.id);
                }
            });

            each(this.floors, (floor) => {
                if (floor.isChecked) {
                    data.append('user_floor[]', floor.id);
                }
            });

            const headers = { 'Authorization': this.$store.getters.getAuthorizationHeaders, 'Content-Type': 'multipart/form-data' };
            const approved_methods = filter(this.notification_types, { isChecked: true });
            const use_methods = map(approved_methods, v => v.id );
            const errored = [];
            const success = [];

            const spinner = await this.$ionic.loadingController.create({
                message: 'One moment while we send your messages...'
            });

            spinner.present();

            if (use_methods.includes('text')) {
                try {
                    await axios.post(`${rootUrl}/account/${this.subscription.code}/emergency_message/sms/`, data, { headers: headers });
                    success.push('text');
                } catch (e) {
                    console.error('Failed to send text messages');
                    console.error(e);
                    errored.push('text');
                }
            }

            if (use_methods.includes('email')) {
                try {
                    await axios.post(`${rootUrl}/account/${this.subscription.code}/emergency_message/email/`, data, { headers: headers });
                    success.push('text');
                } catch (e) {
                    console.error('Failed to send email messages');
                    console.error(e);
                    errored.push('email');
                }
            }

            if (use_methods.includes('massey-app-notification')) {
                try {
                    await axios.post(`${rootUrl}/account/${this.subscription.code}/emergency_message/push/`, data, { headers: headers });
                    success.push('massey-app-notification');
                } catch (e) {
                    console.error('Failed to send push notifications');
                    console.error(e);
                    errored.push('massey-app-notification');
                }
            }

            let message_header = 'All of your messages were sent successfully.';
            if (success.length !== use_methods.length) {
                message_header = 'One or more your messages could not be sent. Please try again, or reach out to support for assistance.';
            }

            const alert = await this.$ionic.alertController.create({
                header: message_header,
                buttons: [{
                    text: 'OK',
                    handler: () => {
                        this.$store.commit('resetMessage');
                        this.$router.push('/action');
                    },
                }]
            });
            
            spinner.dismiss();
            alert.present();
        
        },

        async sendMessage() {

            const confirm = await this.$ionic.alertController.create({
                header: 'Are you sure you want to send this notification?',
                buttons: [{
                    text: 'Yes',
                    handler: this.messageHandler
                },{
                    text: 'No',
                    role: 'cancel'
                }]
            });

            await confirm.present();

        }
    }
};